import { format } from "date-fns";
import { fr } from "date-fns/locale";

/**
 * buildBmiChart - Version SVG custom
 * Retourne { ALL: {...}, 1Y: {...}, 6M: {...}, 1M: {...} }
 */
export default function buildBmiChart(history = []) {

  if (!Array.isArray(history) || history.length === 0) {
    return {
      ALL: { labels: [], values: [] },
      '1Y': { labels: [], values: [] },
      '6M': { labels: [], values: [] },
      '1M': { labels: [], values: [] }
    };
  }

  const sorted = [...history].sort((a, b) => 
    new Date(a.date) - new Date(b.date)
  );

  const filterByPeriod = (data, months) => {
    if (months === null) return data;
    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setMonth(cutoff.getMonth() - months);
    return data.filter(item => new Date(item.date) >= cutoff);
  };

  const createRangeData = (filteredData) => {
    if (filteredData.length === 0) {
      return { labels: [], values: [] };
    }
    return {
      labels: filteredData.map(item => 
        format(new Date(item.date), "MMM dd", { locale: fr })
      ),
      values: filteredData.map(item => parseFloat(item.imc))
    };
  };

  const result = {
    ALL: createRangeData(sorted),
    '1Y': createRangeData(filterByPeriod(sorted, 12)),
    '6M': createRangeData(filterByPeriod(sorted, 6)),
    '1M': createRangeData(filterByPeriod(sorted, 1))
  };

  return result;
}

/**
 * buildBmiChartForChartJS (ancienne version pour Chart.js)
 * Gardée pour référence si vous voulez utiliser Chart.js plus tard
 */
export function buildBmiChartForChartJS(history = []) {
  if (!Array.isArray(history) || history.length === 0) {
    return { data: null, options: defaultOptions() };
  }

  const sorted = [...history].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const labels = sorted.map((e) =>
    format(new Date(e.date), "MMM yyyy", { locale: fr })
  );
  const bmiData = sorted.map((e) => parseFloat(e.imc));

  return {
    data: {
      labels,
      datasets: [
        {
          label: "BMI",
          data: bmiData,
          borderColor: "#006eea ",
          tension: 0.4,
          fill: false,
        },
      ],
    },
    options: defaultOptions(),
  };
}

function defaultOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 15,
        max: 40,
        ticks: { color: "#888" },
        grid: { drawBorder: false, color: "#f0f0f0" },
      },
      x: {
        ticks: { color: "#888" },
        grid: { drawBorder: false, display: false },
      },
    },
    plugins: { legend: { display: false } },
  };
}